<template>
  <div class="email-activities">
    <div v-if="dataLength">
      <div
        v-for="(item, index) in emailActivities"
        :key="index"
        class="email-activities__container">
        <accordian
          :expanded="item.expanded"
          :item="item"
          :index="index"
          @onCardToggle="onAccordianToggle">
          <div
            slot="accordian-header-content"
            class="email-activities__container__accordian-header">
            <div class="email-activities__container__accordian-header__content">
              <div
                class="email-activities__container__accordian-header__content__info">
                <span
                  class="email-activities__container__accordian-header__content__info__name--bold">
                  Case Number
                </span>
                <span
                  v-tooltip="formatDate(item.case_number)"
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ item?.case_number }}
                </span>
              </div>
              <div
                class="email-activities__container__accordian-header__content__info">
                <span
                  class="email-activities__container__accordian-header__content__info__name--grey">
                  From
                </span>
                <span
                  v-tooltip="formatDate(item?.contact_email)"
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ item?.contact_email }}
                </span>
              </div>
              <div
                class="email-activities__container__accordian-header__content__info">
                <span
                  class="email-activities__container__accordian-header__content__info__name--grey">
                  To
                </span>
                <span
                  v-tooltip="
                    formatDate(getToRecipientsList(item.email_messages))
                  "
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ getToRecipientsList(item.email_messages) }}
                </span>
              </div>
              <div
                class="email-activities__container__accordian-header__content__info subject">
                <span
                  class="email-activities__container__accordian-header__content__info__name--grey">
                  Subject
                </span>
                <span
                  v-tooltip="formatDate(item.subject)"
                  class="email-activities__container__accordian-header__content__info__name--ellipsis">
                  {{ item.subject }}
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="item.expanded && item.email_messages"
            slot="accordian-body"
            class="email-activities__container__accordian-body">
            <div class="email-activities__container__accordian-body__item">
              <span
                class="email-activities__container__accordian-body__item__header">
                <span>Case Number</span>
                <span>Created Time</span>
                <Button
                  v-tooltip="'Download Email'"
                  appearance="tertiary"
                  icon="tray-arrow-down"
                  icon-position="left"
                  icon-only
                  class="email-activities__container__accordian-body__item__title__download"
                  @onClick="
                    downloadSurchargeEmail(
                      item?.email_messages?.records,
                      item?.subject
                    )
                  " />
              </span>
              <span
                class="email-activities__container__accordian-body__item__header-value">
                <span>{{ item?.case_number }}</span>
                <span> {{ formatDate(item.created_date) }}</span>
                <span></span>
              </span>
            </div>
            <div
              v-for="(elt, indexCount) in item.email_messages.records"
              :key="indexCount">
              <div class="email-activities__container__accordian-body__item">
                <span
                  class="email-activities__container__accordian-body__item__title">
                  Subject
                </span>
                <span
                  class="email-activities__container__accordian-body__item__value">
                  {{ elt.subject }}
                </span>
              </div>
              <div class="email-activities__container__accordian-body__item">
                <span
                  class="email-activities__container__accordian-body__item__title">
                  Email content
                </span>
                <div
                  class="email-activities__container__accordian-body__item__value"
                  v-html="elt?.html_body"></div>
              </div>
            </div>
          </div>
        </accordian>
      </div>
    </div>

    <h4 v-else class="email-activities__not-found">No Email Found</h4>
  </div>
</template>

<script>
//Actions
import { fileActions } from "@/actions";
import { disputeActions } from "@/actions";
// Util
import { format } from "date-fns";
import AxiosFetchForMsal from "@/utils/axiosForMsal";
import { getMsalIdToken } from "@/utils/helpers";
import { saveAs, saveTextAs } from "file-saver";

export default {
  name: "SfdcEmails",
  props: {
    caseData: {
      type: Object,
      default: () => {},
    },
    sfdcCaseId: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      emailContent: null,
      emailCache: [],
      clickedOnPrevBtn: false,
      emailActivities: [],
      sfdcCaseNumber: this.sfdcCaseId,
    };
  },
  computed: {
    dataLength() {
      return this.emailActivities?.length > 0;
    },
  },
  async mounted() {
    try {
      this.$emit("hideLoader");
      this.$emit("showLoader", "tabContainer");
      const { data } = await AxiosFetchForMsal(
        disputeActions.getSfdcEmailList(
          this.caseData.tpDocumentNumber,
          `Bearer ${await getMsalIdToken(this)}`
        )
      );
      this.emailActivities = data || [];
      if (this.sfdcCaseId?.length) {
        this?.emailActivities?.forEach(async (item, inx) => {
          if (this.sfdcCaseId?.indexOf(item?.case_number) > -1) {
            await this.onAccordianToggle(item, inx);
          }
        });
      }
      event.stopPropagation();
      this.$emit("hideLoader");
    } catch (error) {
      this.$emit("hideLoader");
      console.error(error);
    }
  },
  methods: {
    formatDate(date) {
      try {
        return date
          ? format(new Date(`${date}`), "dd-MMM-yyyy hh:mm a")
          : "N/A";
      } catch (err) {
        return date;
      }
    },
    async onAccordianToggle(clickedItem, index) {
      let newArray = [...this.emailActivities];
      newArray[index] = {
        ...clickedItem,
        expanded: !clickedItem.expanded,
      };
      this.emailActivities = newArray;
    },
    getToRecipientsList(toRecipients) {
      return toRecipients?.records?.map((item) => item?.to_address)?.join(",");
    },
    getFormattedAttachments(data) {
      return data.map((item) => ({
        fileName: item?.name,
        type: item?.file_extension || item?.name.split(".").pop(),
        id: item?.id,
      }));
    },
    async downloadSurchargeEmail(records, subject) {
      try {
        this.$emit("hideLoader");
        this.$emit("showLoader", "tabContainer");
        window.print();
        this.$emit("hideLoader");
      } catch (error) {
        this.$emit("hideLoader");
        console.error(error);
      }
    },
    test() {
      alert("");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";
.email-activities {
  background: var(--Gray-50);
  &__not-found {
    color: var(--Gray-900);
    margin: 1rem;
  }
  &__pagination {
    display: flex;
    margin-top: 16px;
    justify-content: flex-end;
    &__previous {
      &:hover {
        background-color: rgba(66, 176, 213, 0.5) !important;
        color: #fff !important;
      }
    }
    &__next {
      margin-left: 16px;
      &:hover {
        background-color: rgba(66, 176, 213, 0.5) !important;
        color: #fff !important;
      }
    }
  }
  &__container {
    margin: 1rem 0;
    cursor: pointer;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      width: 20px;
      height: 20px;
      background-color: var(--Blue-800);
      border-radius: 24px;
      margin-top: 32px;
    }

    &::after {
      content: "";
      height: calc(100% + 8px);
      position: absolute;
      top: 42px;
      left: 9px;
      width: 2px;
      background-color: var(--Blue-800);
    }

    &:last-child {
      margin-bottom: 0;

      &::after {
        content: none;
      }
    }

    &__accordian-header {
      display: flex;
      align-items: center;

      &__content {
        display: flex;
        align-items: center;

        @include media("<tablet") {
          flex-direction: column;
        }

        &__info {
          display: flex;
          flex-direction: column;
          margin-right: 2rem;
          font-family: "Maersk Text";
          font-size: 14px;
          color: var(--Blue-900-Darkest);
          text-transform: capitalize;
          width: 180px;
          &__name {
            font-size: 16px;
            margin-bottom: 4px;
            &--bold {
              font-weight: bold;
            }
            &--grey {
              font-weight: bold;
              color: var(--Gray-600);
            }
            &--ellipsis {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .subject {
          width: 380px;
        }
      }
    }

    &__accordian-body {
      padding: 1rem;
      border: 1px solid var(--Gray-200);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      display: flex;
      flex-direction: column;
      margin-left: 60px;
      cursor: default;

      @include media("<tablet") {
        margin-left: 40px;
      }

      &__item {
        display: flex;
        margin-bottom: 16px;
        flex-direction: column;
        &__header {
          color: var(--Gray-600);
          margin-bottom: 4px;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          &__download {
            float: right;
            cursor: pointer;
          }
          i {
            font-style: normal;
          }
        }
        &__title {
          color: var(--Gray-600);
          margin-bottom: 4px;
          font-size: 14px;
          &__download {
            float: right;
            cursor: pointer;
          }
          i {
            font-style: normal;
          }
        }
        &__value {
          font-size: 16px;
        }
        &__header-value {
          font-size: 16px;
          display: flex;
          justify-content: space-between;
          & span:nth-child(3) {
            width: 18px;
          }
        }
      }
    }
  }
}
</style>
